import {
    IAtualizarProponente,
    IListProponentesResponse,
    IPostProponentes,
    IRemoverProponente,
} from "../../../Interfaces/Vendas/Proponentes/ProponentesInterface";
import AxiosVendas from "../../Config/ApiVendas";
import Service from "../../Service";

export async function ProponentesGetVendasService(idCaso: number) {
    return Service(
        AxiosVendas.get<Array<IListProponentesResponse>>(
            `/app/proponente?idCaso=${idCaso}`
        )
    );
}

export async function ProponentesPostVendasService(
    requestBody: IPostProponentes
) {
    return Service(AxiosVendas.post(`/app/proponente`, requestBody));
}

export async function AtualizarProponentesVendasService(
    requestBody: IAtualizarProponente
) {
    return Service(AxiosVendas.put(`/app/proponente`, requestBody));
}

export async function RemoverProponentesVendasService(
    requestBody: IRemoverProponente
) {
    return Service(
        AxiosVendas.delete(`/app/proponente`, { data: requestBody })
    );
}
